/* v94.2 Motion Lab picks. Neon flicker once in view, split-flap countdown and balance, gold confetti plus a
   Cash or Rusty line after a successful add to cart (product page and quick add: it listens for /cart/add
   responses, so it only fires when the item really went in). Reduced motion: no flicker, no flips, no confetti. */
(function () {
  if (window.__pwMotion) return; window.__pwMotion = 1;
  var RM = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var rm = function () { return RM.matches; };
  var ready = function (f) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', f); else f(); };

  /* Neon */
  function neon() {
    var els = document.querySelectorAll('[data-pw-neon]');
    if (!els.length || rm() || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-flick'); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Split-flap */
  function cell() {
    var c = document.createElement('i'); c.className = 'pw-flap__c'; c.setAttribute('aria-hidden', 'true');
    c.innerHTML = '<i class="pw-flap__h t"><i></i></i><i class="pw-flap__h b"><i></i></i><i class="pw-flap__h ft"><i></i></i><i class="pw-flap__h fb"><i></i></i>';
    var k = c.children;
    return { el: c, t: k[0].firstChild, b: k[1].firstChild, ft: k[2].firstChild, fb: k[3].firstChild, ftH: k[2], fbH: k[3], cur: '', q: Promise.resolve() };
  }
  function setNow(c, ch) { c.t.textContent = c.b.textContent = c.ft.textContent = c.fb.textContent = ch; c.cur = ch; }
  function flip(c, ch) {
    return new Promise(function (res) {
      if (ch === c.cur) return res();
      if (rm() || !c.ftH.animate || document.hidden) { setNow(c, ch); return res(); }
      var old = c.cur; c.cur = ch;
      c.t.textContent = ch; c.b.textContent = old; c.ft.textContent = old; c.fb.textContent = ch;
      var a1 = c.ftH.animate([{ transform: 'perspective(200px) rotateX(0deg)' }, { transform: 'perspective(200px) rotateX(-90deg)' }], { duration: 90, easing: 'ease-in', fill: 'forwards' });
      a1.onfinish = function () {
        var a2 = c.fbH.animate([{ transform: 'perspective(200px) rotateX(90deg)' }, { transform: 'perspective(200px) rotateX(0deg)' }], { duration: 90, easing: 'ease-out', fill: 'forwards' });
        a2.onfinish = function () { c.b.textContent = ch; c.ft.textContent = ch; a1.cancel(); a2.cancel(); res(); };
      };
    });
  }
  function build(host, str) {
    var cells = [];
    for (var i = 0; i < str.length; i++) {
      if (str[i] === ' ') { var s = document.createElement('i'); s.className = 'pw-flap__sp'; host.appendChild(s); cells.push(null); continue; }
      var c = cell(); host.appendChild(c.el); cells.push(c);
    }
    return cells;
  }
  function write(cells, str, anim) {
    cells.forEach(function (c, i) {
      if (!c) return; var ch = str[i] || '';
      if (anim) c.q = c.q.then(function () { return flip(c, ch); }); else setNow(c, ch);
    });
  }
  /* 11:59:59 pm US Eastern on the given YYYY-MM-DD */
  function etEnd(ymd) {
    var p = String(ymd).split('-').map(Number), y = p[0], m = p[1], d = p[2];
    if (!y || !m || !d) return NaN;
    var nov = new Date(Date.UTC(y, 10, 1)).getUTCDay(), dstEnd = 1 + ((7 - nov) % 7);
    var mar = new Date(Date.UTC(y, 2, 1)).getUTCDay(), dstStart = 8 + ((7 - mar) % 7);
    var dst = (m > 3 && m < 11) || (m === 3 && d >= dstStart) || (m === 11 && d < dstEnd);
    return Date.UTC(y, m - 1, d, 23, 59, 59) + (dst ? 4 : 5) * 3600e3;
  }
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  /* Countdown: the strip always shows the board; the product page shows a plain line until 7 days out. */
  var UNITS = ['DAYS', 'HRS', 'MIN', 'SEC'];
  function parts(t) {
    var s = Math.max(0, Math.floor((t - Date.now()) / 1000));
    var d = Math.floor(s / 86400); s %= 86400; var h = Math.floor(s / 3600); s %= 3600; var m = Math.floor(s / 60); s %= 60;
    return [d > 99 ? 99 : d, h, m, s];
  }
  function board(o) {
    o.h.textContent = ''; o.h.className = 'pw-flapb pw-flapb--' + o.mode; o.h.setAttribute('aria-hidden', 'true');
    o.cells = [];
    UNITS.forEach(function (u) {
      var w = document.createElement('i'); w.className = 'pw-flapb__u';
      var row = document.createElement('i'); row.className = 'pw-flapb__d';
      var c1 = cell(), c2 = cell(); row.appendChild(c1.el); row.appendChild(c2.el); o.cells.push(c1, c2);
      var lb = document.createElement('i'); lb.className = 'pw-flapb__l'; lb.textContent = u;
      w.appendChild(row); w.appendChild(lb); o.h.appendChild(w);
    });
    o.kind = 'board'; write(o.cells, parts(o.t).map(pad).join(''), false);
  }
  function plain(o, d) {
    o.h.className = 'pw-cd-text'; o.h.removeAttribute('aria-hidden');
    o.h.innerHTML = '<b></b> left to order' + (o.label ? ' for ' : '');
    o.h.firstChild.textContent = d + (d === 1 ? ' day' : ' days');
    if (o.label) o.h.appendChild(document.createTextNode(o.label));
    o.kind = 'text'; o.d = d;
  }
  function render(o, anim) {
    if (!(o.t > Date.now())) { (o.h.closest('[data-pw-hc-until]') || o.h).hidden = true; return; }
    var d = Math.floor((o.t - Date.now()) / 86400000);
    if (o.mode === 'pdp' && d > 7) { if (o.kind !== 'text' || o.d !== d) plain(o, d); return; }
    if (o.kind !== 'board') { board(o); return; }
    write(o.cells, parts(o.t).map(pad).join(''), anim);
  }
  var clocks = [], ticking = false;
  function countdowns() {
    document.querySelectorAll('[data-pw-flap-until]').forEach(function (h) {
      if (h.__pwf) return; h.__pwf = 1;
      var o = { h: h, t: etEnd(h.getAttribute('data-pw-flap-until')), mode: h.getAttribute('data-pw-flap-mode') || 'strip', label: h.getAttribute('data-pw-flap-label') || '' };
      render(o, false); clocks.push(o);
    });
    if (clocks.length && !ticking) {
      ticking = true;
      setInterval(function () {
        if (document.hidden) return;
        clocks.forEach(function (o) { if (o.h.isConnected) render(o, true); });
      }, 1000);
    }
  }
  var DIG = '0123456789';
  function balances(root) {
    var sel = '[data-pw-flap-text], .pwor__me .pwor__stat:first-child > b';
    (root || document).querySelectorAll(sel).forEach(function (h) {
      if (h.__pwf) return;
      var txt = (h.textContent || '').trim();
      if (!txt || txt.length > 12) return;
      h.__pwf = 1; h.textContent = '';
      var vh = document.createElement('i'); vh.className = 'pw-vh'; vh.textContent = txt; h.appendChild(vh);
      var box = document.createElement('i'); box.className = 'pw-flap pw-flap--num'; box.setAttribute('aria-hidden', 'true'); h.appendChild(box);
      var cells = build(box, txt);
      if (rm() || !('IntersectionObserver' in window)) { write(cells, txt, false); return; }
      write(cells, txt.replace(/[0-9]/g, '0'), false);
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return; io.disconnect();
        cells.forEach(function (c, i) {
          if (!c) return; var ch = txt[i];
          setTimeout(function () {
            if (/[0-9]/.test(ch)) for (var k = 0; k < 3; k++) (function () { var r = DIG[(Math.random() * 10) | 0]; c.q = c.q.then(function () { return flip(c, r); }); })();
            c.q = c.q.then(function () { return flip(c, ch); });
          }, i * 60);
        });
      }, { threshold: 0.5 });
      io.observe(h);
    });
  }
  function cartBalance(root) {
    (root || document).querySelectorAll('[data-pw-odd-cart] b').forEach(function (b) {
      var n = b.nextSibling;
      if (n && n.nodeType === 3 && /^\s*Oddities apply/.test(n.textContent)) b.setAttribute('data-pw-flap-text', '');
    });
  }

  /* Confetti and a line */
  var LINES = ['Cash: "Good. That one pays rent."', 'Rusty: "Can I have it? It\'s for me."', 'Cash: "Added. I have noted this."', 'Rusty: "WE SOLD ONE. Wait, you bought it."', 'Cash: "Sensible. Mostly."', 'Rusty: "Best. Choice. Ever."'];
  var COLORS = ['#F2B544', '#F2B544', '#F2B544', '#D99A22', '#F7D48A', '#FBF8F3', '#2B3A67'];
  var last = null;
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('button,[type=submit]') : null;
    if (b && (b.name === 'add' || b.closest('form[action*="/cart/add"]'))) last = { el: b, at: Date.now() };
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && f.action.indexOf('/cart/add') > -1) { var b = e.submitter || f.querySelector('[type=submit]'); if (b) last = { el: b, at: Date.now() }; }
  }, true);
  function origin() {
    var b = last && Date.now() - last.at < 15000 ? last.el : null, r = b && b.isConnected ? b.getBoundingClientRect() : null;
    if (r && r.width && r.bottom > 0 && r.top < innerHeight) return { x: r.left + r.width / 2, y: r.top + r.height / 2, r: r };
    return { x: innerWidth / 2, y: innerHeight * 0.6, r: null };
  }
  function say(o) {
    var i = 0; try { i = (parseInt(sessionStorage.getItem('pwcf') || '0', 10) || 0); sessionStorage.setItem('pwcf', String(i + 1)); } catch (e) { i = (Math.random() * LINES.length) | 0; }
    var old = document.querySelector('.pw-cf-say'); if (old) old.remove();
    var p = document.createElement('p'); p.className = 'pw-cf-say'; p.setAttribute('role', 'status'); p.textContent = LINES[i % LINES.length];
    document.body.appendChild(p);
    var w = p.offsetWidth, h = p.offsetHeight, top, lft;
    if (o.r) { top = o.r.bottom + 10; if (top + h > innerHeight - 12) top = o.r.top - h - 10; lft = o.r.left + o.r.width / 2 - w / 2; }
    else { top = innerHeight - h - 24; lft = (innerWidth - w) / 2; }
    p.style.top = Math.max(12, Math.min(innerHeight - h - 12, top)) + 'px';
    p.style.left = Math.max(16, Math.min(innerWidth - w - 16, lft)) + 'px';
    requestAnimationFrame(function () { p.classList.add('is-on'); });
    setTimeout(function () { p.classList.remove('is-on'); setTimeout(function () { p.remove(); }, 250); }, 2600);
  }
  function burst(x, y) {
    var cv = document.createElement('canvas'); cv.className = 'pw-cf-canvas'; cv.setAttribute('aria-hidden', 'true');
    var d = Math.min(2, window.devicePixelRatio || 1), W = innerWidth, H = innerHeight;
    cv.width = W * d; cv.height = H * d; document.body.appendChild(cv);
    var ctx = cv.getContext('2d'); ctx.setTransform(d, 0, 0, d, 0, 0);
    var R = function (a, b) { return a + Math.random() * (b - a); }, parts = [], n = W < 600 ? 70 : 100;
    for (var k = 0; k < n; k++) {
      var a = -Math.PI / 2 + R(-1.25, 1.25), s = R(4, 10.5);
      parts.push({ x: x, y: y, vx: Math.cos(a) * s, vy: Math.sin(a) * s, r: R(0, 6.28), vr: R(-0.3, 0.3), w: R(4, 8), h: R(7, 13), c: COLORS[(Math.random() * COLORS.length) | 0], life: 0, max: R(60, 95), circ: Math.random() < 0.18 });
    }
    (function step() {
      ctx.clearRect(0, 0, W, H);
      parts = parts.filter(function (p) { return p.life < p.max; });
      parts.forEach(function (p) {
        p.vy += 0.24; p.vx *= 0.982; p.vy *= 0.982; p.x += p.vx; p.y += p.vy; p.r += p.vr; p.life++;
        ctx.save(); ctx.globalAlpha = Math.min(1, (p.max - p.life) / (p.max * 0.3)); ctx.translate(p.x, p.y); ctx.rotate(p.r); ctx.scale(1, Math.cos(p.life * 0.22));
        ctx.fillStyle = p.c;
        if (p.circ) { ctx.beginPath(); ctx.arc(0, 0, p.w / 2, 0, 6.28); ctx.fill(); } else ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });
      if (parts.length) requestAnimationFrame(step); else cv.remove();
    })();
  }
  var lastFire = 0;
  function celebrate() {
    if (Date.now() - lastFire < 800) return; lastFire = Date.now();
    var o = origin(); say(o); if (!rm()) burst(o.x, o.y);
  }
  window.pwCelebrate = celebrate;
  var of = window.fetch;
  if (of) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/add/.test(url)) p.then(function (r) { if (r && r.ok) setTimeout(celebrate, 60); }).catch(function () {});
      return p;
    };
  }

  ready(function () {
    neon(); countdowns(); cartBalance(); balances();
    var drawer = document.querySelector('cart-drawer, #CartDrawer, cart-notification');
    if (drawer && 'MutationObserver' in window) {
      var tm; new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(function () { cartBalance(drawer); balances(drawer); }, 120); }).observe(drawer, { childList: true, subtree: true });
    }
  });
})();
